import { ReactElement, useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { formatTimeWithSeconds } from "../../../system/utils";
import StyledTableRow from "../../../components/styledTableRow";
import { IColumn, ISample } from "../../../types";
import TableContainer  from "../../../components/tableContainer";

const columns: IColumn[] = [
  {
    id: "measured",
    label: "Datetime",
    minWidth: 100,
    align: "center",
    format: value => formatTimeWithSeconds(value)
  },
  {
    id: "sample",
    label: "Sample ID",
    minWidth: 200
  },
  {
    id: "S",
    label: "S",
    minWidth: 100,
    align: "right"
  },
  {
    id: "MgO",
    label: "MgO",
    minWidth: 100,
    align: "right",
  },
  {
    id: "CaO",
    label: "O2 CaO",
    minWidth: 100,
    align: "right",
  },
  {
    id: "FeO",
    label: "FeO",
    minWidth: 100,
    align: "right",
  },
  {
    id: "Al2O3",
    label: "Al2O3",
    minWidth: 100,
    align: "right",
  },
  {
    id: "SiO2",
    label: "SiO2",
    minWidth: 100,
    align: "right",
  },
  {
    id: "MnO",
    label: "MnO",
    minWidth: 100,
    align: "right",
  },
  {
    id: "Cr2O3",
    label: "Cr2O3",
    minWidth: 100,
    align: "right",
  },
  {
    id: "TiO2",
    label: "TiO2",
    minWidth: 100,
    align: "right",
  },
  {
    id: "P2O5",
    label: "P2O5",
    minWidth: 100,
    align: "right",
  },
  {
    id: "Vr",
    label: "Vr",
    minWidth: 100,
    align: "right",
  },
  {
    id: "B3Ratio",
    label: "B3Ratio",
    minWidth: 100,
    align: "right",
  },
  {
    id: "Sum",
    label: "Sum",
    minWidth: 100,
    align: "right",
  }
];


interface ISlagChemistry {
  sample: string;
  measured: number;
  S: number | null;
  MgO: number | null;
  CaO: number | null;
  FeO: number | null;
  Al2O3: number | null;
  SiO2: number | null;
  MnO: number | null;
  Cr2O3: number | null;
  TiO2: number | null;
  P2O5: number | null;
  Vr: number | null;
  B3Ratio: number | null;
  Sum: number | null;
}

interface IProps {
  data: ISample[];
}

const SlagChemistryPanel = ({ data }: IProps): ReactElement => {
  const [ rows, setRows ] = useState<ISlagChemistry[]>([]);

  useEffect(() => {

    const result: ISlagChemistry[] = [];

    data.forEach(r => {
      if (r.items.find(i => i.name === "B3Ratio")) {
        const item: Record<string, any> = {
          sample: r.sampleType.code,
          measured: r.sampleDatetime,
        };

        r.items.forEach(i => item[i.name] = i.value);

        result.push(item as ISlagChemistry);
      }
    });

    setRows(result);
  }, data);

  // const createSortHandler = (property: keyof IEquipmentLife) => () => {
  //   const isAsc = orderBy === property && order === "asc";
  //   setOrder(isAsc ? "desc" : "asc");
  //   setOrderBy(property);
  // };

  return (
    <div>
      <TableContainer>
        <Table stickyHeader={true} size={"small"} >
          <TableHead>
            <TableRow>
              {columns.map((column) =>
                <TableCell
                  className="table-header"
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, width: column.minWidth }}>
                  {column.label}
                </TableCell>
              )}
              <TableCell className="table-header"/>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => {
              return (
                <StyledTableRow hover={true} role="checkbox" tabIndex={-1} key={`temp-row-${index}`}>
                  {columns.map((column: IColumn) => {
                    const value = row[column.id as keyof ISlagChemistry];

                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format && typeof value === "number" ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                  <TableCell/>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default SlagChemistryPanel;
